"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const TrialsConfigurationYieldHeader_vue_1 = __importDefault(require("./TrialsConfigurationYieldHeader.vue"));
const TrialsConfigurationYieldMain_vue_1 = __importDefault(require("./TrialsConfigurationYieldMain.vue"));
// SERVICES
const TrialsService_1 = __importDefault(require("../Abstract/services/TrialsService"));
let TrialsConfigurationYield = class TrialsConfigurationYield extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.trialsService = new TrialsService_1.default();
        this.locationsForLine = 0;
    }
    async created() {
        await this.trialsService.callInitialData(this.urlParams);
        await this.trialsService.callProjectSamples(this.urlParams);
        //this.handleResize();
    }
    get isLoading() {
        return this.trialsService.isLoading;
    }
    fakeAssignation() {
        /*         this.trialsService.updateSampleAssignation(new AssignationPayload({
                    location_id: -1,
                    samples: [],
                    treatment_id: -1,
                    time: -1
                })) */
    }
    updateLocationTime(l) {
        this.trialsService.updateLocationTime(l);
    }
    updateAssignatedSamples(payload) {
        this.trialsService.updateSampleAssignation(payload);
    }
    updateSentSamples(payload) {
        this.trialsService.updateSentSamples(payload);
    }
    get urlParams() {
        const url = window.location.search;
        const urlParams = new URLSearchParams(url);
        const projectId = urlParams.get('project');
        const proposalId = urlParams.get('proposal');
        return { projectId: projectId, proposalId: proposalId };
    }
    get trialsMeta() {
        return this.trialsService.collectMeta;
    }
    get times() {
        return this.trialsService.collectTimes;
    }
    get locations() {
        return this.trialsService.collectLocations;
    }
    get samples() {
        return this.trialsService.collectSamples;
    }
    get counters() {
        return this.trialsService.collectCounters;
    }
    launchCrumb(name) {
        this.$emit('launchcrumb', name);
    }
};
TrialsConfigurationYield = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Yield: bmk_ui_framework_1.Yield,
            TrialsConfigurationYieldHeader: TrialsConfigurationYieldHeader_vue_1.default,
            TrialsConfigurationYieldMain: TrialsConfigurationYieldMain_vue_1.default,
        },
    })
], TrialsConfigurationYield);
exports.default = TrialsConfigurationYield;
